import { forwardRef } from 'react';
import { isFunction } from 'lodash';
import { Alert } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import type { SnackbarProps } from './Snackbar/SnackbarProps.interface';
import type { AlertProps } from '@mui/material';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'inline-block',
  },
  action: {
    margin: theme.spacing(1.5, 0, 0, 0),
    padding: 0,

    '& > button': {
      marginRight: theme.spacing(1),
    },
  },
}));

interface SnackbarAlertProps extends Omit<AlertProps, 'action'> {
  readonly action?: SnackbarProps['action'];
  readonly onClose?: SnackbarProps['onClose'];
}

export const SnackbarAlert = forwardRef<HTMLDivElement, SnackbarAlertProps>(({
  action,
  color,
  severity,
  onClose = () => {},
  ...restProps
}, ref) => {
  const { classes } = useStyles();

  const actionComponent = isFunction(action) ? action(onClose) : action;

  return (
    <Alert
      ref={ref}
      elevation={4}
      aria-describedby="client-snackbar"
      variant="standard"
      classes={classes}
      action={actionComponent}
      color={color || severity}
      {...restProps}
    />
  );
});
